module.exports = __webpack_public_path__ + "img/tips1_botlist6img3.d4421a20.jpg";